import {
	Box,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import type { Command } from "../../types/command.types";
import { CommandStatus } from "../../types/command.types";
import ChangeModelerOrderForm, {
	type ChangeModelerOrderFormType,
} from "../forms/ChangeModelerOrderForm";
import { UserPen } from "lucide-react";
import { useMutation, useQueryClient } from "react-query";
import {
	updateCommand,
	bulkChangeCommandStatus,
} from "../../mutations/command.mutations";
import { useCallback } from "react";

type Props = {
	orderId: Command["id"];
	isOpen: boolean;
	onOpen: () => void;
	onClose: () => void;
	orderIds?: number[];
	targetStatus?: CommandStatus;
	onSuccess?: () => void;
};

const ChangeManagerOrderModal = (props: Props) => {
	const queryClient = useQueryClient();
	const { mutate: mutateUpdateCommand } = useMutation(updateCommand);
	const { mutate: mutateBulkChangeStatus } = useMutation(
		bulkChangeCommandStatus,
	);

	const isBulkMode = Boolean(props.orderIds && props.orderIds.length > 0);

	const handleSubmit = useCallback(
		(data: ChangeModelerOrderFormType) => {
			if (isBulkMode && props.orderIds && props.orderIds.length > 0) {
				mutateBulkChangeStatus(
					{
						ids: props.orderIds,
						status: props.targetStatus ?? CommandStatus.WAITING_FOR_MODELING,
						modelerId: data.userId,
					},
					{
						onSettled: () => {
							queryClient.invalidateQueries("command");
							queryClient.invalidateQueries("commands");
							queryClient.invalidateQueries("commands-paginated");
							props.onSuccess?.();
							props.onClose();
						},
					},
				);
			} else {
				mutateUpdateCommand(
					{
						id: props.orderId,
						modelerId: data.userId,
					},
					{
						onSettled: () => {
							queryClient.invalidateQueries("command");
							queryClient.invalidateQueries("commands");
							queryClient.invalidateQueries("commands-paginated");
							props.onSuccess?.();
							props.onClose();
						},
					},
				);
			}
		},
		[
			isBulkMode,
			props.orderId,
			props.orderIds,
			props.targetStatus,
			props.onSuccess,
			props.onClose,
			mutateUpdateCommand,
			mutateBulkChangeStatus,
			queryClient,
		],
	);

	return (
		<Modal
			isOpen={props.isOpen}
			onClose={props.onClose}
			isCentered
			closeOnOverlayClick={!isBulkMode}
		>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent maxW={"none"} w="600px">
				<ModalHeader borderBottom="solid 1px #E2E8F0">
					<Flex>
						<Flex
							w="48px"
							h="48px"
							bg="zinc.50"
							border="solid 1px"
							borderColor="brand.100"
							justifyContent="center"
							alignItems="center"
							borderRadius={100}
							mr="8px"
						>
							<UserPen size="24px" color="#1444E1" />
						</Flex>
						<Box>
							<Box lineHeight="48px">Assigner à un modeleur</Box>
						</Box>
					</Flex>
				</ModalHeader>
				<ModalCloseButton onClick={props.onClose} />
				<ModalBody>
					<ChangeModelerOrderForm onSubmit={handleSubmit} />
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default ChangeManagerOrderModal;
